import React from 'react';
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { Button } from '@swiggy-private/dls-web-core/dist/components/Button';
import styles from './CustomRangeModal.module.scss';
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import DatePicker from '@/components/DatePicker/DatePicker';
import { matchDisabledDays, validateRange } from '../../helper';
import { CROSS } from '@/constants/icons/unicode';
const CustomRangeModal = (props) => {
    const { handleClose, handleSelectRange } = props;
    const [startDate, setStartDate] = React.useState();
    const [endDate, setEndDate] = React.useState();
    const handleSelect = () => {
        if (startDate && endDate && validateRange(startDate, endDate)) {
            handleSelectRange(startDate, endDate);
        }
    };
    return (React.createElement("div", { className: styles.container },
        React.createElement(Text, { variant: DlsFontVariants.header_H2_Black, color: DlsColorTokens.text_Highest_Emphasis, className: styles.title }, "Set Custom Date Range"),
        React.createElement(Text, { variant: DlsFontVariants.body_B1_Reg, color: DlsColorTokens.text_Med_Emphasis, className: styles.description }, "Select date range that you want to study campaign performance for. Your performance summary would load for selected dates"),
        React.createElement("div", { className: styles.dateRangeSelector },
            React.createElement(DatePicker, { value: startDate, setValue: (date) => setStartDate(date), label: "Start date", disabledDateMatcher: (date) => matchDisabledDays(date) }),
            React.createElement(DatePicker, { value: endDate, setValue: (date) => setEndDate(date), label: "End date", disabledDateMatcher: (date) => matchDisabledDays(date, startDate) })),
        React.createElement("div", { className: styles.buttonGroup },
            React.createElement("div", { className: styles.cancelButton, onClick: handleClose },
                React.createElement(Text, { variant: DlsFontVariants.body_B1_Bold, color: DlsColorTokens.primary }, "Cancel")),
            React.createElement(Button, { variant: "primary", onClick: handleSelect }, "Select Range")),
        React.createElement("div", { className: styles.closeButton, onClick: handleClose }, String.fromCharCode(CROSS))));
};
export default CustomRangeModal;
